import React from 'react'
import { BackArrowIcon } from '../../Assets/Icons'
import PlanFunctionButton from './PlanFunctionButton'
import ParentGroup from '../ParentGroup'
import { UiComponents } from "@simulanisindia/ui";
import { useNavigate, useParams } from 'react-router-dom'
import ApplicationModulePlanList from './ApplicationModulePlanList'

const PlanModuleCardList = () => {
  const navigate = useNavigate()
  const { BackButton } = UiComponents;
  const params = useParams();
  const { groupId, subscriptionId } = params;
  
  const backClick = () => navigate(-1);

  return (
    <>

      <div className="org-plans">
        <div className="page-title" style={{ border: "none" }}>
          <div className="title-back">
            <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
            <h6> Plans and subscription </h6>
          </div>
        </div>

        <div className="plans-info">
          <div className="org-detail">
            <ParentGroup uuid={groupId} />
          </div>

          <div className="plans-details">
            <div className="plan-list">
              <ApplicationModulePlanList subscriptionId={subscriptionId} />
            </div>

            <div className="plan-function">
              <PlanFunctionButton uuid={groupId} />
            </div>
          </div>

        </div>
      </div>

    </>
  )
}

export default PlanModuleCardList
